import { render } from "./XIconSolidAdjustments.vue?vue&type=template&id=ba7a4414"
import script from "./XIconSolidAdjustments.vue?vue&type=script&lang=js"
export * from "./XIconSolidAdjustments.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"XIconSolidAdjustments.vue"]])

export default __exports__